<template>
  <div class="select-path-template">
    <div>
      <div>{{ methodName }}する書類</div>
      <VuePerfectScrollbar
        class="scroll-area mt-2 mb-4"
        :settings="scrollbarSettings"
      >
      <!-- {{ validate }} -->
        <div
          v-for="(item, index) in targetDocments"
          :key="index"
          class="px-4 py-1 flex items-center"
        >
          <feather-icon
            svgClasses="h-4 w-4"
            class="mr-2"
            :icon="sourceDocumentIcon(item)"
          ></feather-icon>
          <div class="w-11/12 break-all break-words">
            <span class="text-sm">
              {{ sourceDocumentName(item.path) }}
            </span>
          </div>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div>
      <div class="pb-2">{{ methodName }}先</div>
      <div class="flex pb-4 justify-between items-center">
        <div class="px-4 w-10/12 break-all break-words">
          /{{ documentNewPath }}
        </div>
        <div>
          <vx-tooltip text="新規フォルダ作成">
            <vs-button
              class="flex w-full"
              icon-pack="feather"
              icon="icon-folder-plus"
              @click="showCreateFolderDropdown()"
              :color="AISEA_COLOR.BLUE"
            ></vs-button>
          </vx-tooltip>
        </div>
      </div>
      <VuePerfectScrollbar
        class="tree-scroll-area"
        :settings="scrollbarSettings"
      >
        <div>
          <folder-tree-list key="move-dialog-tree" :validate="validate" />
        </div>
      </VuePerfectScrollbar>
    </div>

    <document-create-folder-dialog
      id="document-create-folder-dialog"
      ref="DocumentCreateFolderDialog"
      :isProcessingDialog="true"
    ></document-create-folder-dialog>
  </div>
</template>

<script>

import { createNamespacedHelpers } from "vuex";
import { ColorMixin, DocumentMixin } from "@/mixins";
import FolderTreeList from "./tree/DocumentMoveDialogTreeList";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import DocumentCreateFolderDialog from "../DocumentCreateFolderDialog"

const {
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  mixins: [ColorMixin, DocumentMixin],
  components: { FolderTreeList, VuePerfectScrollbar, DocumentCreateFolderDialog },
  props: {
    targetDocments: {
      type: Array,
      required: true,
      default: () => { return [] }
    },
    methodName: {
      type: String,
      required: true
    },
    validate: {
      type: Function,
    }
  },
  data () {
    return {
      documentName: "",
      error: { message: null },
      replaceText: "置き換える",
    };
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "documentNewPath",
      "documentRootPath"
    ]),
  },
  methods: {
    sourceDocumentIcon (document) {
      if (!document.type) return "FolderIcon"
      return this.getDocumentMimeIcon(document.type)
    },
    sourceDocumentName (name) {
      return name.replace(this.documentRootPath, "")
    },
    showCreateFolderDropdown () {
      this.$refs.DocumentCreateFolderDialog.show(this.documentNewPath)
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.select-path-template {
  z-index: 288;

  .scroll-area {
    max-height: 120px;
  }

  .add-folder-icon {
    color: $aisea-pure-white;
    background: $aisea-blue;
  }

  .tree-scroll-area {
    max-height: 240px;
  }

  #document-create-folder-dialog {
    z-index: 289;
  }

}
</style>
